import { Routes } from '@angular/router';
import { AuthGuardService } from './core/guard/auth-guard/auth-guard.service';

// All feature components are lazy-loaded via loadComponent() so the initial bundle only
// carries the app shell + landing route - admin/approvals/reports/countermeasure/
// view-questions code is fetched on-demand the first time their route is navigated to,
// instead of shipping upfront in the eager main bundle.
export const routes: Routes = [
    {
        path: '', redirectTo: 'home', pathMatch: 'full'
    },
    {
        path: 'home',
        loadComponent: () => import('./core/layout/home/home.component').then(m => m.HomeComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'admin',
        loadComponent: () => import('./core/layout/admin/admin.component').then(m => m.AdminComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'reports',
        loadComponent: () => import('./core/layout/reports/reports.component').then(m => m.ReportsComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'approvals',
        loadComponent: () => import('./core/layout/approvals/approvals.component').then(m => m.ApprovalsComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'home/view-questions/:category/:affiliate/:id',
        loadComponent: () => import('./core/layout/view-questions/view-questions.component').then(m => m.ViewQuestionsComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'approvals/view-questions/:category/:affiliate/:id',
        loadComponent: () => import('./core/layout/view-questions/view-questions.component').then(m => m.ViewQuestionsComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'countermeasures/view-questions/:category/:affiliate/:id',
        loadComponent: () => import('./core/layout/view-questions/view-questions.component').then(m => m.ViewQuestionsComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'countermeasures',
        loadComponent: () => import('./core/layout/countermeasure/countermeasure.component').then(m => m.CountermeasureComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('./core/layout/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: 'not-found',
        loadComponent: () => import('./core/layout/pagenotfound/pagenotfound.component').then(m => m.PagenotfoundComponent),
        canActivate:[AuthGuardService]
    },
    {
        path: '**',
        loadComponent: () => import('./core/layout/pagenotfound/pagenotfound.component').then(m => m.PagenotfoundComponent),
        canActivate:[AuthGuardService]
    }

];
